import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "linked-paths-box"
}
const _hoisted_2 = { class: "linked-paths-box-contents" }
const _hoisted_3 = { class: "linked-paths-summary" }

import PathPicker from './PathPicker.vue';
import IslandBadge from './IslandBadge.vue';
import { PathViewModel } from '@/features/bots/models/designer';
import { useStore } from 'vuex';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkedPathsBox',
  setup(__props) {

const store = useStore();
const linkedPaths = computed<PathViewModel[]>(() => store.getters.linkedPaths);

return (_ctx: any,_cache: any) => {
  return (linkedPaths.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(IslandBadge, {
          type: "linkedpaths",
          draggable: false
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkedPaths.value, (linkedPath) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "path",
                key: linkedPath.id
              }, [
                _createVNode(PathPicker, {
                  value: linkedPath.id,
                  fixed: true
                }, null, 8, ["value"])
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})